<template>
    <div class="body-scan">

        <div class="current">
            <div class="single-chart">
                <svg class="circular-chart" viewBox="-1 -0.4 38 37">
                    <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" :style="'stroke: ' + colour +';'"/>
                    <path class="circle" :stroke-dasharray="percentage + ', 100'" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" :style="'stroke: ' + colour +';'"/>
                    <text x="18" y="20.35" class="percentage">{{ percentage }}%</text>
                </svg>
            </div>
            <div class="data">
                <h5>Current</h5>
                <h4>{{ label }}</h4>
                <p>{{ value }} <span>{{ unit }}</span></p>
            </div>
        </div>
        <div class="target">
            <div class="data">
                <h5>Target</h5>
                <h4>{{ label }}</h4>
                <p v-if="editting != target">{{ targets[target] }} <span>{{ unit }}</span>
                    <v-btn v-if="!saving && realWeek <= currentWeek" fab light small color="primary" v-on:click.prevent="toggleEdit(target, $event)">
                        <v-icon light style="font-size:20px;height:30px;width:30px;">edit</v-icon>
                    </v-btn>
                </p>
                <div v-if="editting === target && !saving" class="data-editor-container">
                    <v-form @submit.prevent="saveEdit(target)" @keyup.enter.native.prevent="saveEdit(target)">
                        <v-text-field
                            type="number"
                            label=""
                            single-line
                            solo
                            dense
                            hide-details
                            class="mb-2 edit-field"
                            v-model="targets[target]" :id="target" :ref="target" v-on:blur="clearEdit()"
                        ></v-text-field>
                    </v-form>
                    <v-layout>
                        <v-btn class="edit-btn" @click.prevent.stop="saveEdit(target)" fab light small color="success"><v-icon light>check</v-icon></v-btn>
                    </v-layout>
                </div>
                <p class="starting">Starting {{ label }}<br><span style="white-space: nowrap;">{{ starting }} {{ unit }}</span></p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

    export default {
        name: "EvoltGraph",
        props: ['target', 'label', 'value', 'unit', 'target_label', 'colour', 'starting'],
        computed: {
            ...mapGetters({
                currentWeek: 'challenge/currentWeek',
                realWeek: 'challenge/realWeek'
            }),
            ...mapState({
                targets: state => state.data.targets
            }),
            percentage () {
                if(this.starting === 0 || !this.targets[this.target] || this.targets[this.target] === 0) return 0

                let start_diff = this.targets[this.target] - this.starting
                let current_diff = this.value - this.starting

                let percent = start_diff / current_diff * 100
                if (start_diff > current_diff)
                    percent = current_diff / start_diff * 100

                if(start_diff === 0) return 0

                percent = current_diff / start_diff * 100

                return percent.toFixed(0)

                /*
                let percent = (parseInt(this.targets[this.target]) / (this.starting) * 100)
                if(parseInt(this.targets[this.target]) > (this.starting)) percent = ((this.starting) / parseInt(this.targets[this.target]) * 100)
                return percent.toFixed(0)
                 */
            }
        },
        data() {
            return {
                editting: null,
                saving: false,
                lastValue: null
            }
        },
        methods: {
            toggleEdit: function (field, e) {
                this.editting = field
                this.lastValue = this.targets[this.target]
                this.$nextTick(() => {
                    //console.log(this.$refs[field])
                    this.$refs[field].focus()
                })
            },
            saveEdit: async function (field) {


                var data = {}

                if (isNaN(parseFloat(this.targets[field])))
                    this.targets[field] = 0

                this.targets[field] = parseFloat(this.targets[field]).toFixed(1)

                data[field] = parseFloat(this.targets[field])

                this.lastValue = this.targets[field]

                this.saving = true
                this.editting = null
                this.$store.dispatch('data/updateTargets', data).then(() => {
                    this.saving = false
                }).catch(() => {
                    this.targets[this.target] = this.lastValue
                    this.editting = null
                    this.saving = false
                })

            },
            clearEdit: function () {
                if(this.saving) return
                setTimeout(() => {
                    if (!this.saving) {
                        this.targets[this.target] = this.lastValue
                        this.editting = null
                    }
                }, 500)
            }
        }
    }
</script>

<style lang="scss">

    .body-scan {
        margin-top: 10px;
        display: flex;
        .data {
            text-transform: uppercase;
            h4 {
                font-size: 20px;
                font-weight: 300;
                margin-bottom:0;
            }
            p {
                font-size: 30px;
                font-weight: 200;
                margin-bottom: 0;
                span {
                    font-weight:500;
                    font-size: 15px;
                }
            }
            p.starting {
                font-size: 14px;
            }
        }
        .current {
            width: 70%;
            background-color: #eee;
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 15px;
            display: flex;
            align-items: center;
            .single-chart {
                width: 50%;
                .circle-bg {
                    fill: none;
                    stroke: #B4D1D8;
                    stroke-width: 4.5;
                    opacity: 0.5;
                }

                .circle {
                    fill: none;
                    stroke-width: 4.5;
                    animation: progress 1s ease-out forwards;
                }

                @keyframes progress {
                    0% {
                        stroke-dasharray: 0 100;
                    }
                }
                .circular-chart {
                    display: block;
                    width: 80%;
                    margin:0;
                    .circle {
                        stroke: #0096BF;
                    }
                }
                .percentage {
                    fill: #555;
                    font-family: sans-serif;
                    font-size: .6em;
                    font-weight: 200;
                    text-anchor: middle;
                }
            }
        }

        .target {
            width: 50%;
            border: 1px solid #ddd;
            border-radius: 4px;
            margin-left: 10px;
            padding: 15px;
            display:flex;
            align-items: center;
            button {
                background-color: #24adbb;
                border-radius: 50%;
                padding: 5px;
                width: 25px;
                height: 25px;
                margin-left: 15px;
            }
            .data-editor-container {
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                .edit-field {
                    width: 75%;
                }
                .edit-btn {
                    right: 22px;
                }
            }
        }
    }

    @media only screen
    and (max-device-width: 375px) {
        .body-scan {
            padding: 5px 10px 0 10px;
            margin: 5px;
            .data {
                h4 {
                    font-size: 15px;
                }
                p {
                    font-size: 25px;
                }
            }
            .current {
                width: 60%;
            }
            .target {
                width: 50%;
            }
        }
    }


</style>
